"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsClass = void 0;
var tslib_1 = require("tslib");
var react_gtm_module_1 = tslib_1.__importDefault(require("react-gtm-module"));
var types_1 = require("./types");
var AnalyticsClass = function () {
  function AnalyticsClass(gtmTag, errorHandler) {
    var _this = this;
    this.analyticsEnabled = false;
    this.logEvent = function (params) {
      if (_this.analyticsEnabled) {
        try {
          react_gtm_module_1.default.dataLayer({
            dataLayer: params
          });
        } catch (e) {
          if (typeof _this.errorHandler !== 'undefined') {
            _this.errorHandler(e);
          }
        }
      }
    };
    this.trackCTAButton = function (routeName) {
      _this.logEvent({
        event: 'Click',
        category: "".concat(routeName, " page"),
        label: "CTA button - ".concat(routeName)
      });
    };
    this.trackClick = function (category, label) {
      _this.logEvent({
        event: 'Click',
        category: category,
        label: label
      });
    };
    this.trackQuizAnswer = function (category, label) {
      _this.logEvent({
        event: 'Quiz question answered',
        category: category,
        label: label
      });
    };
    this.trackShippingFormSubmitted = function () {
      _this.logEvent({
        event: 'Shipping form',
        category: 'Submit',
        label: 'Shipping form submitted'
      });
    };
    this.trackPaymentSubmit = function (method, orderName) {
      _this.logEvent({
        event: 'payment_initialized',
        payment_method: method,
        subscription_plan: orderName
      });
    };
    this.trackingLandingUrl = function (landingUrl) {
      _this.logEvent({
        event: 'landing_url',
        landingUrl: landingUrl,
        label: 'User has landed on landing page'
      });
    };
    this.trackPurchase = function (orderId, currency, orderSku, orderTitle, price, email, quantity) {
      _this.logEvent({
        event: 'purchase_main',
        pageCategory: 'successPage',
        email: email,
        transactionId: orderId,
        transactionTotal: price,
        currencyCode: currency,
        transactionProducts: [{
          sku: orderSku,
          name: orderTitle,
          price: price,
          quantity: quantity || 1
        }]
      });
    };
    this.trackPurchaseUpsell = function (orderId, currency, orderSku, orderTitle, price, quantity) {
      _this.logEvent({
        event: 'purchase_upsell',
        pageCategory: 'successPage',
        transactionId: orderId,
        transactionTotal: price,
        currencyCode: currency,
        transactionProducts: [{
          sku: orderSku,
          name: orderTitle,
          price: price,
          quantity: quantity || 1
        }]
      });
    };
    this.trackPurchaseUpsellOnePager = function (orderId, currency, totalPrice, upsells) {
      _this.logEvent({
        event: 'purchase_upsell_one_pager',
        pageCategory: 'successPage',
        transactionId: orderId,
        transactionTotal: totalPrice,
        currencyCode: currency,
        transactionProducts: upsells
      });
    };
    this.trackSuccessPurchase = function (params) {
      _this.logEvent(tslib_1.__assign({
        event: types_1.EventType.Purchase
      }, params));
    };
    this.trackPayment = function (params) {
      _this.logEvent(tslib_1.__assign({
        event: types_1.EventType.AddPaymentInfo
      }, params));
    };
    this.trackShipping = function (params) {
      _this.logEvent(tslib_1.__assign({
        event: types_1.EventType.AddShippingInfo
      }, params));
    };
    this.trackLead = function (params) {
      _this.logEvent(tslib_1.__assign({
        event: types_1.EventType.GenerateLead
      }, params));
    };
    this.trackCheckout = function (params) {
      _this.logEvent(tslib_1.__assign({
        event: types_1.EventType.BeginCheckout
      }, params));
    };
    this.trackQuiz = function () {
      _this.logEvent({
        event: types_1.EventType.StartQuiz
      });
    };
    this.trackAnswer = function (params) {
      _this.logEvent(tslib_1.__assign({
        event: types_1.EventType.QuizQuestionAnswered
      }, params));
    };
    this.errorHandler = errorHandler;
    this.analyticsEnabled = !!gtmTag;
    if (this.analyticsEnabled && typeof document !== 'undefined' && !window.dataLayer) {
      if (typeof react_gtm_module_1.default !== 'undefined') {
        react_gtm_module_1.default.initialize({
          gtmId: gtmTag
        });
      } else {
        console.warn('TagManager is undefined');
      }
    }
  }
  return AnalyticsClass;
}();
exports.AnalyticsClass = AnalyticsClass;